import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchCurrentUser, logout as logoutRequest, type CurrentUserResponse } from "../services/auth.service";

const AUTH_QUERY_KEY = ["auth", "me"];

export function useAuth() {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery<CurrentUserResponse>({
    queryKey: AUTH_QUERY_KEY,
    queryFn: fetchCurrentUser,
    staleTime: 60_000,
  });

  const logout = async (): Promise<void> => {
    await logoutRequest();
    queryClient.setQueryData(AUTH_QUERY_KEY, { user: null, impersonatedBy: null });
    queryClient.clear();
  };

  return {
    user: data?.user ?? null,
    impersonatedBy: data?.impersonatedBy ?? null,
    isImpersonating: !!data?.impersonatedBy,
    isLoading,
    isAuthenticated: !!data?.user,
    logout,
  };
}
